"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var trim_1 = __importDefault(require("./trim"));

var MINIUM_EMAIL_PARTS = 2;

function parseEmail(emailStr) {
  var email = trim_1.default(emailStr);
  var parts = email.split('@');

  if (parts.length < MINIUM_EMAIL_PARTS) {
    return false;
  }

  for (var i = 0; i < parts.length; i++) {
    if (parts[i] === '') {
      return false;
    }
  } // FYI, in hello@example.com
  // secondLevelDomain -> example
  // topLevelDomain -> com


  var sld = '';
  var tld = '';
  var domain = parts.pop();
  var domainParts = domain.split('.');

  if (domainParts.length === 0) {
    // The address does not have a top-level domain
    return false;
  } else if (domainParts.length == 1) {
    // The address has only a top-level domain (valid under RFC)
    tld = domainParts[0];
  } else {
    // The address has a domain and a top-level domain
    sld = domainParts[0];

    for (var j = 1; j < domainParts.length; j++) {
      tld += domainParts[j] + '.';
    }

    tld = tld.substring(0, tld.length - 1);
  }

  return {
    topLevelDomain: tld,
    secondLevelDomain: sld,
    domain: domain,
    address: parts.join('@')
  };
}

exports.default = parseEmail;